import { get } from 'lodash';

import {
  apiGetCjAppointmentConversion,
  apiGetCjPatientConversion,
} from '../endpoints/cj-endpoints';

const trackAppointmentConversion = (appointment) => {
  // Pull out required properties
  const appointmentId = get(appointment, 'id');
  const appointmentPrice = get(appointment, 'metadata.billingPrice');
  const country = get(
    appointment,
    'patient.metadata.wizardData.location.address.country',
  );
  const promoCode = get(appointment, 'requestData.dmProps.promoCode');
  const cjEvent = get(appointment, 'requestData.cjEvent');

  // Quietly terminate if NPR isn't attached to a CJ event
  if (!cjEvent) {
    return;
  }

  apiGetCjAppointmentConversion(
    appointmentId,
    appointmentPrice,
    country,
    promoCode,
    cjEvent,
  );
};

const trackPatientConversion = (patient, cjEvent) => {
  if (!cjEvent) {
    return;
  }

  apiGetCjPatientConversion(patient.id, cjEvent);
};

export default { trackAppointmentConversion, trackPatientConversion };
